import { MapContainer, TileLayer, Marker, Popup, useMap } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import { useEffect } from 'react';

// Fix Leaflet default icon issue with webpack
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png',
  iconUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png',
  shadowUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png',
});

const cleanerIcon = new L.Icon({
  iconUrl: 'data:image/svg+xml;base64,' + btoa(`
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="42" viewBox="0 0 32 42">
      <path d="M16 0C7.16 0 0 7.16 0 16c0 11.2 16 26 16 26s16-14.8 16-26C32 7.16 24.84 0 16 0z" fill="#2D5A3C"/>
      <circle cx="16" cy="16" r="6" fill="white"/>
    </svg>
  `),
  iconSize: [32, 42],
  iconAnchor: [16, 42],
  popupAnchor: [0, -42]
});

const customerIcon = new L.Icon({
  iconUrl: 'data:image/svg+xml;base64,' + btoa(`
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="42" viewBox="0 0 32 42">
      <path d="M16 0C7.16 0 0 7.16 0 16c0 11.2 16 26 16 26s16-14.8 16-26C32 7.16 24.84 0 16 0z" fill="#DDA77B"/>
      <circle cx="16" cy="16" r="6" fill="white"/>
    </svg>
  `),
  iconSize: [32, 42],
  iconAnchor: [16, 42],
  popupAnchor: [0, -42]
});

const FitBounds = ({ cleaners, customerLocation }) => {
  const map = useMap();
  
  useEffect(() => {
    const points = [];
    if (customerLocation) points.push([customerLocation.lat, customerLocation.lng]);
    cleaners.forEach(c => {
      if (c.latitude && c.longitude) points.push([c.latitude, c.longitude]);
    });
    
    if (points.length > 0) {
      const bounds = L.latLngBounds(points);
      map.fitBounds(bounds, { padding: [50, 50], maxZoom: 14 });
    }
  }, [cleaners, customerLocation, map]);
  
  return null;
};

const CleanerMap = ({ cleaners = [], customerLocation = null, onSelectCleaner, height = '500px' }) => {
  const defaultCenter = customerLocation 
    ? [customerLocation.lat, customerLocation.lng]
    : cleaners.length > 0 && cleaners[0].latitude
    ? [cleaners[0].latitude, cleaners[0].longitude]
    : [40.7506, -73.9971]; // Default to NYC

  return (
    <div className="rounded-2xl overflow-hidden border border-border" style={{ height }} data-testid="cleaner-map">
      <MapContainer
        center={defaultCenter}
        zoom={13}
        style={{ height: '100%', width: '100%' }}
        scrollWheelZoom={false}
      >
        <TileLayer
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
        />
        
        <FitBounds cleaners={cleaners} customerLocation={customerLocation} />
        
        {customerLocation && (
          <Marker position={[customerLocation.lat, customerLocation.lng]} icon={customerIcon}>
            <Popup>
              <div className="font-heading font-semibold">Your Location</div>
            </Popup>
          </Marker>
        )}
        
        {cleaners.map((cleaner) => {
          if (!cleaner.latitude || !cleaner.longitude) return null;
          return (
            <Marker
              key={cleaner.id}
              position={[cleaner.latitude, cleaner.longitude]}
              icon={cleanerIcon}
            >
              <Popup>
                <div className="min-w-[180px]">
                  <div className="font-heading font-semibold text-text-primary mb-1">{cleaner.name}</div>
                  <div className="text-sm text-text-secondary mb-1">${cleaner.hourly_rate}/hr</div>
                  <div className="text-xs text-text-secondary mb-2">
                    {cleaner.rating_avg > 0 ? `★ ${cleaner.rating_avg.toFixed(1)}` : 'New'}
                    {cleaner.distance_km && ` • ${cleaner.distance_km} km away`}
                  </div>
                  {onSelectCleaner && (
                    <button
                      onClick={() => onSelectCleaner(cleaner)}
                      className="text-xs bg-primary text-white px-3 py-1 rounded-full hover:bg-primary-hover"
                    >
                      View Profile
                    </button>
                  )}
                </div>
              </Popup>
            </Marker>
          );
        })}
      </MapContainer>
    </div>
  );
};

export default CleanerMap;
